import { useContext, useMemo } from 'react'

import useBedbankRates from 'hooks/useBedbankRates'
import { useBedbankRoomRatePromotions } from 'hooks/OfferPage/useBedbankPromotions'
import { getPromotionMinLos, isFlashCalendarEnabled } from 'selectors/offerPage/bedbankOfferPageSelectors'
import { useAppSelector } from './reduxHooks'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { getBedbankPackageViews } from 'lib/hotels/bedbankUtils'
import { initialRooms } from 'lib/offer/occupancyUtils'

function useBedbankPackageViews(
  offer: App.BedbankOffer | undefined,
): [Array<App.BedbankOfferPackageView>, boolean] {
  const offerPageState = useContext(OfferPageStateContext)
  const {
    rooms = initialRooms,
    duration,
    checkInDate: checkIn,
    checkOutDate: checkOut,
  } = offerPageState
  const [{ hotelOnlyRates, hotelBundleRates }, fetchingRates] = useBedbankRates(offer?.id, rooms, checkIn, checkOut)

  const promotionMinLos = useMemo(() => getPromotionMinLos(offer), [offer])
  const isCalendarEnabled = useAppSelector((state) => isFlashCalendarEnabled(offerPageState, state))
  const promotions = useBedbankRoomRatePromotions(offer?.promotions, checkIn, checkOut)

  const result = useMemo(() => {
    return getBedbankPackageViews(offer, rooms, duration, checkIn, checkOut, hotelOnlyRates, hotelBundleRates, promotionMinLos, isCalendarEnabled, promotions)
  }, [offer, promotions, checkIn, checkOut, hotelOnlyRates, hotelBundleRates, promotionMinLos, duration, isCalendarEnabled, rooms])

  return [result, fetchingRates]
}

export default useBedbankPackageViews
